export const SERVER_ENDPOINT = 'http://34.242.138.186';
